import type { GridComparatorFn, GridSortDirection } from "@mui/x-data-grid-premium";

export const getDateSortComparator =
  (direction: GridSortDirection): GridComparatorFn<Date | null> =>
  (a, z) => {
    if (a === null && z === null) return 0;
    if (a === null) return 1;
    if (z === null) return -1;
    const diff = a.getTime() - z.getTime();
    return direction === "desc" ? -diff : diff;
  };
